export const WILLOW_HOME = 'https://willow.tech';
/** The Terms of Service the sign-up page's agreement line links to: their
 *  effective date, as `effectiveDate` in willow-website's src/legal/pages.ts.
 *  Change it whenever that date changes. */
export const TERMS_VERSION = '2026-11-04';
export const WILLOW_GITHUB = 'https://github.com/willow-network';
export const WILLOW_X = 'https://x.com/willow_protocol';
export const WILLOW_DISCORD = 'https://discord.gg/BrrA56x24f';
export const BLOCKCHAIN_EXPLORER_URL = 'https://explorer.willow.tech';
